import { authenticatedRestClient } from 'helpers/restclient';

export default class UserService {
	static instance = new UserService();

	_endpoints = {
		notificationPreferences: (userId) => `/api/users/${userId}/notification_preferences`,
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	getNotificationPreferences = (userId) => {
		const endpoint = this._endpoints.notificationPreferences(userId);
		return this.restClient.get(endpoint);
	};

	updateNotificationPreferences = (userId, data) => {
		const endpoint = this._endpoints.notificationPreferences(userId);
		return this.restClient.put(endpoint, data);
	};
}
